import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppSettings } from './app/app.settings';

if (environment.production) {
  enableProdMode();
  AppSettings.URL_GESTOR = AppSettings.URL_GESTOR_PRODUCAO;
  AppSettings.URL_TRIBUTOS = AppSettings.URL_TRIBUTOS_PRODUCAO;
  AppSettings.emProducao = true;
} else {
  AppSettings.URL_GESTOR = AppSettings.URL_GESTOR_HOMOLOGACAO;
  AppSettings.URL_TRIBUTOS = AppSettings.URL_TRIBUTOS_HOMOLOGACAO;
  AppSettings.emProducao = false;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
